import React from "react";

export default function NotificationsCenter({ isOpen, onClose }) {
  const handleClick = () => onClose();

  return (
    <div className={`notifications-center ${isOpen ? "" : "hidden"}`}>
      <div className="notifications-header">
        <h2>Notifications</h2>
        <button onClick={handleClick}>
          <span className="arrow" />
        </button>
      </div>
      <div className="notifications-list">
        <div className="notification-item">
          <h3>Today</h3>
          <p>You have a new message from John Doe</p>
        </div>
        <div className="notification-item">
          <h3>Yesterday</h3>
          <p>Your application has been reviewed</p>
        </div>
        <div className="notification-item">
          <h3>Last Week</h3>
          <p>New job postings available in your area</p>
        </div>
      </div>
      <div className="settings-footer">
        <button
          className="support-btn"
          onClick={() => (window.location.href = "/support")}
        >
          Contact support
        </button>
      </div>
    </div>
  );
}
